import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppLayout from './components/AppLayout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import AccountPage from './pages/AccountPage';
import AccountIntegrationsPage from './pages/AccountIntegrationsPage';
import RelationshipsPage from './pages/RelationshipsPage';
import RelationshipOverviewPage from './pages/RelationshipOverviewPage';
import RelationshipInteractionsPage from './pages/RelationshipInteractionsPage';
import RelationshipInterestsPage from './pages/RelationshipInterestsPage';
import RelationshipFamilyPage from './pages/RelationshipFamilyPage';
import RelationshipEmploymentPage from './pages/RelationshipEmploymentPage';
import NewRelationshipPage from './pages/NewRelationshipPage';

const RequireAuth = () => {
  const { isAuthenticated, accessToken } = useAuth();
  return isAuthenticated && accessToken ? <Outlet /> : <Navigate to="/login" replace />;
};

const RedirectIfAuthenticated = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" replace /> : children;
};

const AppRoutes = () => (
  <Routes>
    <Route
      path="/login"
      element={
        <RedirectIfAuthenticated>
          <LoginPage />
        </RedirectIfAuthenticated>
      }
    />
    <Route
      path="/signup"
      element={
        <RedirectIfAuthenticated>
          <SignupPage />
        </RedirectIfAuthenticated>
      }
    />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/oauth/callback" element={<OAuthCallbackPage />} />

    <Route element={<RequireAuth />}>
      <Route element={<AppLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/account/integrations" element={<AccountIntegrationsPage />} />
        <Route path="/relationships" element={<RelationshipsPage />} />
        <Route path="/relationships/new" element={<NewRelationshipPage />} />
        <Route path="/relationship/:id" element={<RelationshipOverviewPage />} />
        <Route path="/relationship/:id/interaction" element={<RelationshipInteractionsPage />} />
        <Route path="/relationship/:id/interests" element={<RelationshipInterestsPage />} />
        <Route path="/relationship/:id/family" element={<RelationshipFamilyPage />} />
        <Route path="/relationship/:id/employment" element={<RelationshipEmploymentPage />} />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
